export default {
    created() {
        this.$helpers.removeScrollingBehavior();
    },
    beforeDestroy() {
        this.$helpers.addScrollingBehavior(this.$router.currentRoute.path);
    } 
};